import React, { useState } from 'react';
import ReportTypeManagement from '../../../components/siteadmin/ReportTypeManagement/ReportTypeManagement';
import { withQuery } from '../../../hoc/withGraphql';
import { getAllReportType } from '../../../lib/graphql';
import Loader from '../../../components/Loader/Loader';
import withStyles from 'isomorphic-style-loader/withStyles';
import CustomPagination from '../../../components/CustomPagination/CustomPagination';

import cs from '../../../components/commonStyle.css';


function ManageReportType(props) {
    const { data: { getAllReportType, refetch, loading } } = props;

    const [currentPage, setCurrentPage] = useState(1)
    const [searchList, setSearchList] = useState('');

    const setStateVariable = (varaiable) => {
        if (varaiable.currentPage !== undefined) {
            setCurrentPage(varaiable.currentPage)
        }
        if (searchList !== undefined) setSearchList(searchList);
    }

    const paginationData = (newPage) => {
        const variables = { currentPage: newPage, searchList };
        setCurrentPage(newPage);
        refetch(variables);
    };

    return (
        <div>
            {loading && <div><Loader type={"text"} /></div>}

            {!loading && <ReportTypeManagement
                currentPage={currentPage}
                getAllReportType={getAllReportType}
                setStateVariable={setStateVariable}
                searchList={searchList}
                refetch={refetch}
            />}
            {getAllReportType?.count > 0 && (
                <CustomPagination
                    total={getAllReportType?.count}
                    currentPage={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={10}
                    change={paginationData}
                    isScroll
                />
            )}
        </div>
    )
}

export default withQuery(getAllReportType, {
    options: (props) => ({
        variables: {
            currentPage: 1,
            searchList: ''
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
})(withStyles(cs)(ManageReportType))